import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = () => ({
  root: {
    display: 'block',
    flex: 'none',
    margin: 0,
    width: 'auto',
  },
});

const SummaryCardDataCell = ({
  className, classes, label, value,
}) => {
  return (
    <Box className={classNames(classes.root, className)}>
      <Typography color={'primaryGray'}>{label}</Typography>
      <Typography color={'black'} weight={'bold'} variant={'h4'}>{value}</Typography>
    </Box>
  );
};

SummaryCardDataCell.defaultProps = {
  className: '',
};

SummaryCardDataCell.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(SummaryCardDataCell);
